/** Button that opens the TranslationBoostModal. Shows the current translation count when > 0. */
import { Globe } from 'lucide-react'

interface TranslationBoostButtonProps {
  postId: string
  count: number
  onOpenModal: () => void
}

export function TranslationBoostButton({ count, onOpenModal }: TranslationBoostButtonProps) {
  const activeColor = 'var(--brand)'

  return (
    <button
      type="button"
      onClick={onOpenModal}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '7px 9px',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        borderRadius: 'var(--radius-pill)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-sm)',
        fontWeight: 600,
        color: 'var(--text-muted)',
        transition: 'background var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = `color-mix(in srgb, ${activeColor} 12%, transparent)`
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'none'
      }}
    >
      <Globe size={18} />
      {count > 0 && <span>{count}</span>}
    </button>
  )
}
